<template>
   <span v-if="selectedGroup && selectedGroup.subgroups && selectedGroup.subgroups.length === 0">
    <div v-if="selectedGroup.subgroupExercises && selectedGroup.subgroupExercises.length > 0" v-for="currentExercise in this.selectedGroup.subgroupExercises" :key="currentExercise.id">
      <exercises :subgroupExercise="currentExercise"></exercises>
      <button @click.prevent="back()" type="submit" class="btn btn-primary pull-right margin">{{$t('pages.exercise.back')}}</button>
    </div>
    <!-- <infinite-loading v-if="loading" @infinite="infiniteHandler"></infinite-loading> -->
    <div v-if="selectedGroup.subgroupExercises && selectedGroup.subgroupExercises.length === 0">
      {{$t('pages.subgroups.emptySubgroup')}}
    </div>
   </span>
   <span v-else-if="examExercises && examExercises.length > 0">
    <div v-for="(currentExercise, i) in examExercises" :key="currentExercise.id">
      <exercises :index="i" :examExercise="currentExercise.data" v-if="examResults"></exercises>
      <div v-else>
        <exercises :index="i + indexOffset" :examExercise="currentExercise" :exercisesNumber="exercisesNumber" v-if="exercisesNumber"></exercises>
        <exercises :index="i" :examExercise="currentExercise" v-else></exercises>
      </div>
    </div>
   </span>
</template>

<script>
import Exercises from '@/components/exercises/Exercises'
// import InfiniteLoading from 'vue-infinite-loading'
export default {
  name: 'exercises-list',
  data () {
    return {
      loading: true,
      subsetOfExercises: []
    }
  },
  props: ['selectedGroup', 'examExercises', 'indexOffset', 'exercisesNumber'],
  components: {
    'exercises': Exercises
  },
  mounted () {
    // if (this.selectedGroup && this.selectedGroup.subgroupExercises) this.subsetOfExercises = this.selectedGroup.subgroupExercises.slice(0, 2) || this.selectedGroup.subgroupExercises
  },
  computed: {
    examResults () {
      return this.$route.name === 'classExamResults' || this.$route.name === 'classExamResultsAdmin'
    }
  },
  methods: {
    /* infiniteHandler ($state) {
      setTimeout(() => {
        // console.log('nov arr', this.subsetOfExercises)
        let len = this.subsetOfExercises.length
        let hasLoadedSth = false
        for (let i = this.subsetOfExercises.length; i <= len && i < this.selectedGroup.subgroupExercises.length; i++) {
          this.subsetOfExercises.push(this.selectedGroup.subgroupExercises[i])
          hasLoadedSth = true
        }
        if (!hasLoadedSth) this.loading = false
        $state.loaded()
      }, 50)
    }, */
    back () {
      this.$router.go(-1)
    }
  }
}
</script>




// WEBPACK FOOTER //
// ExercisesList.vue?718350e8